import useDocumentCreator from "../../../engine/hooks/useDocumentCreator";
import { roles } from "../../../utils/constants";
import { Button, Space } from "antd";
import { AiFillFileExcel } from "react-icons/ai";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FilePdfOutlined } from "@ant-design/icons";
import { createXMLString, downloadXML } from "../../../utils/bills.xml";
import { http } from "../../../engine/api/http";
import { TbFileTypeXml } from "react-icons/tb";
import { BillsExportsExcel } from "./BillsExportsExcel";
import _ from "lodash";
import { onlyRoleMapping } from "../../../engine/AuthRoute";
import { BillsExportDateModal } from "./BillsExportDateModal";
import { updateBillsDocumentDates } from "../Slices/Billing.slice";

const mergeDocumentDates = (billsToExport, updates) => {
  return billsToExport.map(bill => {
    const update = updates.find(entry => entry.billIds.includes(bill._id));

    if (!update) {
      return bill;
    }

    return {
      ...bill,
      exportedDate: update.documentDate,
    };
  });
};

export const BillsExportFile = ({ type, selectedRowKeys }) => {
  const { bills } = useSelector(state => state.billing);
  const dispatch = useDispatch();
  const [get, createAndGet, isLoading, setUrl, doc] = useDocumentCreator();
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [pendingExportType, setPendingExportType] = useState(null);
  const [savingDocumentDates, setSavingDocumentDates] = useState(false);

  const selectedBills = bills.filter(bill => selectedRowKeys.includes(bill._id));
  const isAvic = onlyRoleMapping([roles.admin, roles.permanance]);

  const exportPDF = async (withHeader = true) => {
    createAndGet(
      { ids: selectedRowKeys, withHeader },
      `bills/pdfs`,
      true,
      true,
      () => {},
    );
  };

  const exportXML = async billsToExport => {
    try {
      await http.post("/logs", {
        baseUrl: "/api/bills",
        action: "export",
        route: "/api/bills/xml",
        ressource: "/api/bills/xml",
        content: {
          billsId: selectedRowKeys,
        },
      });

      const xmlString = createXMLString({
        bills: billsToExport,
      });
      downloadXML(xmlString, "bills.xml");
    } catch (e) {
      console.log(e);
    }
  };

  const runExport = async (exportType, updates, withHeader = true) => {
    const billsToExport = mergeDocumentDates(
      bills.filter(bill => selectedRowKeys.includes(bill._id)),
      updates,
    );

    if (exportType === "pdf") {
      await exportPDF(withHeader);
      return;
    }

    await exportXML(billsToExport);
  };

  const handleExportConfirm = async (updates, options = {}) => {
    setSavingDocumentDates(true);

    try {
      await http.patch("/bills/document-dates", { updates });
      dispatch(updateBillsDocumentDates(updates));
      setExportModalOpen(false);
      await runExport(
        pendingExportType,
        updates,
        options.withHeader !== false,
      );
    } catch (e) {
      console.log(e);
    } finally {
      setSavingDocumentDates(false);
      setPendingExportType(null);
    }
  };

  const openExportModal = exportType => {
    setPendingExportType(exportType);
    setExportModalOpen(true);
  };

  const exportExcel = async () => {
    const loggit = await http.post("/logs", {
      baseUrl: "/api/bills",
      action: "export",
      route: "/api/bills/xlxs",
      ressource: "/api/bills/xlxs",
      content: {
        billsId: selectedRowKeys,
      },
    });

    let prestations = [];

    let copy = _.cloneDeep(bills);

    copy
      .filter(e => {
        if (selectedRowKeys !== null) {
          return selectedRowKeys.includes(e._id);
        } else {
          return true;
        }
      })
      .map(bill => {
        bill.prestations.map(presta => {
          presta.bill = bill;
          if (presta.bill !== null && presta.institution !== undefined) {
            presta.bill.intitution = presta.institution;
          }
          presta.institution = bill.institution;

          prestations.push(presta);
        });
      });

    BillsExportsExcel(prestations, false);
  };

  return (
    <>
      <Space>
        {onlyRoleMapping([roles.admin, roles.permanance]) && (
          <Button
            type="default"
            size="large"
            icon={<AiFillFileExcel />}
            disabled={selectedRowKeys.length === 0}
            onClick={() => exportExcel()}
          >
            Export XLXS
          </Button>
        )}

        <Button
          type="default"
          size="large"
          icon={<FilePdfOutlined />}
          loading={isLoading || savingDocumentDates}
          disabled={selectedRowKeys.length === 0}
          onClick={() => openExportModal("pdf")}
        >
          Export PDF
        </Button>

        {onlyRoleMapping([roles.admin, roles.permanance]) && (
          <Button
            type="default"
            size="large"
            icon={<TbFileTypeXml />}
            disabled={selectedRowKeys.length === 0}
            loading={savingDocumentDates}
            onClick={() => openExportModal("xml")}
          >
            Export XML
          </Button>
        )}
      </Space>

      <BillsExportDateModal
        open={exportModalOpen}
        bills={selectedBills}
        confirmLoading={savingDocumentDates}
        onCancel={() => {
          setExportModalOpen(false);
          setPendingExportType(null);
        }}
        onConfirm={handleExportConfirm}
        askHeader={isAvic && pendingExportType === "pdf"}
      />
    </>
  );
};
